import { render, staticRenderFns } from "./RowDrawer.vue?vue&type=template&id=84c4c844&"
import script from "./RowDrawer.vue?vue&type=script&lang=js&"
export * from "./RowDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports